import BannerLeft from './bannerleft/bannerleft.vue'
import BnnerLeftSecond from './BnnerLeftSecond/BnnerLeftSecond.vue'

export default {
    name: 'banner',
    data() {
        return {
            //标签
            labels: {
                id: '0'
            },
            //轮播图
            sliderImgs: [],
            //推荐课程
            recommendCourseImg: [],
            // 板块数组
            sections: [],
            //搜索项目包输入的文字
            searchPackageName: "",

        }
    },
    methods: {
        //返回首页
        toIndex() {
            this.$router.push({
                path: '/'
            });
        },

        //根据项目式的标签请求不同页面

        //为高校教师平台写的特殊方法
        specialPlatform() {
            let address = this.$router.resolve({
                path: '/blank',
                query: {
                    zerotId: 0,
                    lableType: 'zeroLable',
                }
            });
            window.open(address.href, "_blank");
        },


        // //获取项目式的标签
        // allProjectLabel() {
        //     //请求后台数据
        //     let data = {
        //         shop_id: this.$store.state.store.id,
        //         offset: 0,
        //         length: 6
        //     };
        //     //发起请求获取标签
        //     this.$post('product_area/search', data).then(res => {
        //         // console.log(res.data.result);
        //         //获取返回的标签赋值
        //         this.labels.children = res.data.result.data;
        //     })
        // },
        //获取类别标签
        // getLabel() {
        //     //判断是获取项目式还是课程云，若是项目式则调用另一个方法,否则就继续执行
        //     // this.$post('shops/get', { url: window.location.href.split('/#')[0] }).then(res => {
        //     this.$post('shops/get', { url: 'https://education-test.bayou-tech.cn' }).then(res => {
        //         if (res.data.result.is_project != "0") {
        //             this.allProjectLabel();
        //             return false;
        //         } else {
        //             return true;
        //         }
        //     }).then(data => {
        //         if (data) {
        //             this.$post('labels/all', { shop_id: this.$store.state.store.id }).then(res => {
        //                 let data = res.data.result;
        //                 this.allLabel(data, this.labels);
        //                 //判断是否有三级标签，有的话给一级添加个isWidth属性
        //                 for (let one of this.labels.children) {
        //                     if (one.children) {
        //                         innter:
        //                         for (let two of one.children) {
        //                             if (two.children) {
        //                                 for (let three of two.children) {
        //                                     if (three) {
        //                                         one.isWidth = 'true';
        //                                         break innter;
        //                                     }
        //                                 }
        //                             }
        //                         }
        //                     }
        //                 }
        //             })
        //         }
        //     })
        // },

        //跳转区项目包
        projectPackage() {
            let address = this.$router.resolve({
                path: "/project"
            });
            window.open(address.href, "_blank");
        },
        //获取首页数据
        getdata() {
            this.$getStoreId().then(id => {
                this.$post('sections/search', { shop_id: id, offset: 0, length: 999 }).then(res => {
                    this.sections = res.data.result.data;
                    //因为返回的对象里面的数组有产品数组，也有项目包数组，若
                    this.sections.map(item => {
                        //若产品数组为空则删除产品数组这个属性
                        if (item.section_products.length == 0) {
                            //删除项目包数组这个属性
                            item.section_products = item.package_section;
                        }
                        delete item.package_section;
                    })
                    // // console.log(this.sections);
                })
            })

        },
        //获取轮播图图片
        getSliderPhoto() {
            this.$getStoreId().then(id => {
                this.$post('banner/search', { shop_id: id, offset: 0, length: 999 }).then(res => {
                    this.sliderImgs = res.data.result.data;
                    // // console.log(this.sliderImgs)
                })
            })
        },

        toClass(url) {
            var a = document.createElement('a');
            a.setAttribute('href', url);
            a.setAttribute('target', '_blank');
            a.click()
        }

    },
    components: {
        BannerLeft,
        BnnerLeftSecond
    },
    mounted: function () {
        // this.getLabel();
        // this.getdata();
        this.getSliderPhoto();
        document.title = this.$store.state.store.platform_name;
    }
}


